module.exports = __webpack_public_path__ + "static/media/vinarska_oblast_morava.9260d8a1.md";